import { render, staticRenderFns } from "./NotificationItem.vue?vue&type=template&id=747c88ac&"
import script from "./NotificationItem.vue?vue&type=script&lang=js&"
export * from "./NotificationItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/htdocs/samenaankoop/src/vue-apps/cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('747c88ac')) {
      api.createRecord('747c88ac', component.options)
    } else {
      api.reload('747c88ac', component.options)
    }
    module.hot.accept("./NotificationItem.vue?vue&type=template&id=747c88ac&", function () {
      api.rerender('747c88ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "widgets/NotificationItem.vue"
export default component.exports